var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute -bottom-32 -left-36"},[_c('lottie',{attrs:{"width":300,"height":400,"options":_vm.lottieOptions},on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }